import React, { createContext, useContext, useState, useCallback } from 'react';
import { ActingOrg, getActingOrg, setActingOrg as persist } from '../services/actingOrg';

interface Ctx {
  actingOrg: ActingOrg | null;
  enterOrg: (org: ActingOrg) => void;
  exitOrg: () => void;
}
const ActingOrgContext = createContext<Ctx>({ actingOrg: null, enterOrg: () => {}, exitOrg: () => {} });

export const ActingOrgProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [actingOrg, setOrg] = useState<ActingOrg | null>(getActingOrg());
  const enterOrg = useCallback((org: ActingOrg) => {
    persist(org); setOrg(org);
    window.dispatchEvent(new Event('acting-org-changed'));
  }, []);
  const exitOrg = useCallback(() => {
    persist(null); setOrg(null);
    window.dispatchEvent(new Event('acting-org-changed'));
  }, []);
  return <ActingOrgContext.Provider value={{ actingOrg, enterOrg, exitOrg }}>{children}</ActingOrgContext.Provider>;
};

export const useActingOrg = () => useContext(ActingOrgContext);
